import React, { useCallback } from 'react';
import PT from 'prop-types';
import cn from 'classnames';
import Icon from '../../../../../Icon';

const PaginationButton = ({ label, active, disabled, onClick, dataTestId }) => {
  let content;
  switch (label) {
    case 'left':
      content = <Icon name="icon-prev" />;
      break;

    case 'right':
      content = <Icon name="icon-next" />;
      break;

    default:
      content = label;
  }

  const handleButtonClick = useCallback(() => {
    !disabled && onClick(label);
  }, [disabled, onClick, label]);

  return (
    <div
      onClick={handleButtonClick}
      className={cn('pagination-button', {
        'pagination-button_active': active,
        'pagination-button_disabled': disabled,
      })}
      data-testid={dataTestId}
    >
      {content}
    </div>
  );
};

PaginationButton.propTypes = {
  label: PT.oneOfType([PT.string, PT.number]),
  active: PT.bool,
  onClick: PT.func,
};

export default PaginationButton;
